export const About = () => (
  <section id="about" data-testid="about-section" className="py-20 sm:py-24 bg-white border-b border-line">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <span className="label-caps text-forest block mb-4">About Room 9</span>
      <h2 data-testid="about-heading" className="heavy-heading text-3xl sm:text-5xl font-extrabold text-ink leading-tight mb-8">
        A space for ideas to unfold.
      </h2>
      <p data-testid="about-body" className="text-base sm:text-lg text-muted-gd leading-relaxed mb-6">
        Room 9 is a thoughtfully curated rental studio in Ahmedabad, designed for photography,
        video shoots, content creation and workshops.
      </p>
      <p className="text-base sm:text-lg text-muted-gd leading-relaxed mb-10">
        With versatile backdrops, considered props and a comfortable shooting environment, the
        space is designed to adapt to different ideas, aesthetics and concepts.
      </p>
      <p data-testid="about-tagline" className="heavy-heading text-xl sm:text-2xl font-extrabold text-forest tracking-tight">
        Where Ideas Take Shape.
      </p>
    </div>
  </section>
);
